import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  month: string;
}

export function ExportButton({ month }: Props) {
  const handleExport = (): void => {
    // Fallback client-side enquanto o endpoint /exports/:month?format=pdf (task 22.0)
    // não está pronto: usa window.print() com um CSS de impressão preparado
    // na rota /summary. Gera o PDF via "Salvar como PDF" do navegador.
    window.print();
  };

  return (
    <Button
      variant="outline"
      onClick={handleExport}
      aria-label={`Exportar resumo de ${month} em PDF`}
    >
      <Download className="h-4 w-4" />
      Exportar PDF
    </Button>
  );
}
